<ng-container *adaptLoading="!rating || !catchup">
    <h2 class="mb-0">{{ person1 }} & {{ person2 }}</h2>
    <p>
        <small>Entered on {{ catchup!.creationDate | timeAgo }} ({{ catchupDate }})</small>
    </p>
    <p class="d-flex align-items-center">
        Team:
        @if (catchup!.teamId) {
            <adapt-link-team [teamId]="catchup!.teamId"
                             [showIcon]="true"></adapt-link-team>
        }
        @if (!catchup?.teamId) {
            <i aria-hidden="true"
               class="ps-1 fal fa-cubes"></i><span class="ps-1">All teams</span>
        }
    </p>
    <p class="mb-1">
        {{ ratingType?.name }}:
        <adapt-display-rating-value [ratingValue]="rating!.rating"></adapt-display-rating-value>
    </p>
    <!-- If not showing buttons, this will be showing this catchup history where it shouldn't be showing next catchup due
    (historical catchup instances are always due for next catchup!) -->
    @if (areBothPeopleActive && showButtons) {
        <p class="mb-1">
            Next catchup due:
            <span [ngClass]="dueDateClass">{{ formattedNextCatchupDate }}</span>
            ({{ isScheduled ? "scheduled" : "potential date" }})
        </p>
    }
    @if (showCommentDetails) {
        <h3 class="mt-4">How {{ author }} rated {{ ratingSubjectText }}</h3>
        <p class="mb-2">
            <strong>{{ author }}'s Comment:</strong>
        </p>
        <div [froalaView]="rating!.comment"></div>
        @if (rating!.feedbackComment) {
            <p class="mt-4 mb-2">
                <strong>{{ feedbackPerson }}'s Feedback:</strong>
            </p>
            <div [froalaView]="rating!.feedbackComment"></div>
        }
    }

    @if (showButtons) {
        <div class="mt-3 d-flex">
            <button adaptButton="pill"
                    (click)="showCatchup()">More Detail</button>
            @if (canEditPersonalCatchups && areBothPeopleActive) {
                <button adaptButtonIcon="add"
                        class="ms-2 btn btn-primary btn-pill"
                        (click)="recordNewCatchup()">New catch-up</button>
            }
            @if (canEditPersonalCatchups && areBothPeopleActive && isInvolvedPerson) {
                <button adaptButtonIcon="fal fa-calendar-lines-pen"
                        class="ms-2 btn btn-primary btn-pill"
                        (click)="scheduleCatchup()">{{ isScheduled ? "Reschedule" : "Schedule" }} catch-up</button>
            }
        </div>
    }
</ng-container>
